// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Jo-z","slideIn":"Ko-z"};